import React from 'react'

const Main = () => {
  return (
    <div className="container">
      <h3 className="mt-5 pt-5 text-center" style={{height: '600px'}}>Collect everything you can find from anywhere on the internet!</h3>
    </div>
  )
}

export default Main
